export default {
  prepend(h, conf, key) {
    return <template slot="prepend">{conf.__slot__[key]}</template>
  },
  append(h, conf, key) {
    return <template slot="append">{conf.__slot__[key]}</template>
  }
}



// WEBPACK FOOTER //
// ./src/components/form/render/slots/el-input.js